<template>
  <!-- 协议 -->
  <a-modal
    :visible="tipsVisible"
    :title="title"
    @cancel="handleCancel"
    width="90%"
    
  >
    <template slot="footer">
      <a-button
        key="submit"
        type="primary"
        @click="handleCancel"
      >
        我知道了
      </a-button>
    </template>
    <div v-html="cont" class="tips-cont"></div>
  </a-modal>
</template>
<script>
export default {
  props: ['tipsVisible', 'title', 'cont'],
  data() {
    return {
      value: ''
    };
  },
  methods: {
    handleCancel() {
      this.$emit('handleClose')
    }
  }
};
</script>
<style scoped>
.tips-cont {
  max-height: 500px;
  overflow-y: auto;
}
</style>